import { setCheckedList } from '../../redux/files/actionCreators';
import { connect } from 'react-redux';

import CheckboxField from '../../../../../primitives/form/CheckboxField/CheckboxField';

export function CopyField(props) {
  const { files, selectedFile, checkedList, setCheckedList } = props;

  const handleOnChange = (event) => {
    const currentCheckedItem = parseInt(event.target.value);
    const copyCheckedList = [...checkedList];
    const updateCheckList = event.target.checked
      ? [...copyCheckedList, currentCheckedItem]
      : copyCheckedList.filter((check) => {
          if (check !== currentCheckedItem) return check;
        });
    setCheckedList(updateCheckList);
  };

  return (
    <div className="copy-field">
      <div className="form form__center">
        {files
          .filter((file) => file.index !== selectedFile.index && file.status === 'Needs Input')
          .map((file, fileIndex) => {
            return (
              <div key={fileIndex} className="form__group-wrapper form__group-wrapper--half-on-desktop">
                <div className="form__group">
                  <div
                    className={`copy-field__checkbox-wrapper ${
                      checkedList.includes(file.index) ? 'copy-field__checkbox-wrapper--dark-border' : ''
                    }`}
                  >
                    {file.originalFileData.type === undefined ? (
                      <i className="fa fa-file-o" />
                    ) : file.originalFileData.type.includes('video') ? (
                      <i className="fa fa-file-video-o" />
                    ) : file.originalFileData.type.includes('image') ? (
                      <i className="fa fa-file-image-o" />
                    ) : file.originalFileData.type.includes('pdf') ? (
                      <i className="fa fa-file-pdf-o" />
                    ) : (
                      <i className="fa fa-file-o" />
                    )}
                    <CheckboxField
                      showError={false}
                      fieldID={file.index}
                      optionText={file.originalFileData.path}
                      fieldRequired={false}
                      optionValue={file.index}
                      handleChange={handleOnChange}
                      disabled={false}
                      checked={checkedList.includes(file.index)}
                    />
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    checkedList: state.files.checkedList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCheckedList: (checkedValue) => {
      dispatch(setCheckedList(checkedValue));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CopyField);
